<template>
  <div class="ad-banner-page" v-if="currentUser">
    <div class="page-header">
      <div class="page-header-left">
        <router-link to="/admin-profile/ad-banners" class="back-link">
          &#8592; Powrót do listy banerów
        </router-link>
        <h1>Edycja banera reklamowego</h1>
      </div>
    </div>

    <div v-if="isLoading" class="loading-state">
      <p>Ładowanie banera...</p>
    </div>

    <div v-else-if="banner" class="banner-wrap">
      <AdBannerForm :initial-banner="banner" @saved="onSaved" />
    </div>

    <div v-else class="error-state">
      <p>Nie udało się załadować banera.</p>
      <router-link to="/admin-profile/ad-banners" class="btn-outline">
        Powrót do listy
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import authHeader from '@/services/auth-header';
import AdBannerForm from '@/components/AdBannerForm.vue';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'AdBannerEdit',
  components: { AdBannerForm },
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      banner: null,
      isLoading: true,
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
    bannerId() {
      return this.$route.params.id;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
      return;
    }

    if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
      return;
    }

    this.loadBanner();
  },
  methods: {
    loadBanner() {
      this.isLoading = true;

      axios.get(`/admin/ad-banners/${this.bannerId}`, authHeader()).then(res => {
        this.banner = res.data.data || res.data;
      }).catch(() => {
        this.banner = null;
        this.appStore.setIsAlert('Nie udało się pobrać banera');
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onSaved(banner) {
      this.banner = banner;
    },
  },
};
</script>

<style scoped lang="scss">
.ad-banner-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.back-link {
  display: inline-block;
  font-size: 1.4rem;
  color: #10b981;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 8px;
  transition: color 0.2s;
}

.back-link:hover {
  color: #059669;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.loading-state,
.error-state {
  text-align: center;
  padding: 64px 32px;
  color: #9ca3af;
  font-size: 1.6rem;
}

.btn-outline {
  display: inline-block;
  margin-top: 16px;
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 9px 15px;
  font-size: 1.4rem;
  font-weight: 600;
  text-decoration: none;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 640px) {
  .ad-banner-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }
}
</style>